import { alpha, Box, FormControlLabel, FormHelperText, RadioGroup } from '@mui/material';
import FormRadio from './FormRadio';
import { FormComponentValue, FormControlRadioProps, FormElementControlPropsType } from './index';
import { prepareTextDataObject } from 'tools/tools';
import useBundleTranslation from 'i18n';

const disabledStyles = {
    pointerEvents: 'none',
    opacity: 0.5,
};

export default function FormRadioGroup({
    controlProps,
    elementProps,
}: FormElementControlPropsType<FormControlRadioProps>) {
    const { t } = useBundleTranslation(elementProps?.translationNS);

    return (
        <RadioGroup
            sx={controlProps.disabled ? disabledStyles : {}}
            onChange={controlProps.onChange}
            value={controlProps.value}
            row={controlProps.isRow}
            data-test={controlProps.uid}
        >
            {controlProps.data
                .filter((v) => !v.hidden)
                .map((v: FormComponentValue) => {
                    const { text: helperTextValue, getFinalHtml: getHelperText } = prepareTextDataObject(
                        v.props?.helperText ?? '',
                    );

                    return (
                        <>
                            <FormControlLabel
                                hidden={v.hidden}
                                disabled={v.disabled}
                                key={v.value}
                                value={v.value}
                                disableTypography={controlProps.disabled}
                                control={<FormRadio disabled={controlProps.disabled} />}
                                label={
                                    <>
                                        {v.label}
                                        {v?.props?.labelHelper ? (
                                            <>
                                                {' '}
                                                <Box
                                                    component={'span'}
                                                    sx={{ color: (theme) => alpha(theme.palette.text.primary, 0.64) }}
                                                >
                                                    {v.props.labelHelper}
                                                </Box>
                                            </>
                                        ) : (
                                            ''
                                        )}
                                    </>
                                }
                            />
                            {!controlProps.isRow && helperTextValue && (
                                <FormHelperText
                                    sx={{
                                        ml: 3,
                                        mt: 0,
                                        color: (theme) => alpha(theme.palette.text.primary, 0.64),
                                        fontStyle: 'normal',
                                    }}
                                    className={'markdown-holder'}
                                >
                                    {getHelperText(t)}
                                </FormHelperText>
                            )}
                        </>
                    );
                })}
        </RadioGroup>
    );
}
